import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CustomTextField from "../../../components/common/Textfield";

interface UploadDocumentsProps {
  open: boolean;
  setDialogDocumentOpen: (open: boolean) => void;
  documentName: string;
  loading: boolean;
  documentCategory: string;
  documentDescription: string;
  setDocumentName: (name: string) => void;
  setDocumentDescription: (description: string) => void;
  setDocumentCategory: (category: string) => void;
  documentFile: File | null;
  setDocumentFile: (file: File | null) => void;
  handleSaveDocument: () => void;
}

const UploadDocuments: React.FC<UploadDocumentsProps> = ({
  open,
  setDialogDocumentOpen,
  documentName,
  documentCategory,
  documentDescription,
  setDocumentName,
  setDocumentDescription,
  setDocumentFile,
  documentFile,
  loading,
  setDocumentCategory,
  handleSaveDocument,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setDialogDocumentOpen(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Add Document</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>
          <CustomTextField
            label="Document Name"
            value={documentName}
            onChange={(e) => setDocumentName(e.target.value)}
            fullWidth
          />
          <CustomTextField
            label="Document Description"
            value={documentDescription}
            onChange={(e) => setDocumentDescription(e.target.value)}
            fullWidth
          />
          <CustomTextField
            select
            label="Document Category"
            value={documentCategory}
            onChange={(e) => setDocumentCategory(e.target.value)}
            fullWidth
          >
            <MenuItem value="invoice">Invoice</MenuItem>
            <MenuItem value="quotation">Quotation</MenuItem>
            <MenuItem value="internet agreement form">
              Internet Agreement Form
            </MenuItem>
            <MenuItem value="service delivery">Service Delivery</MenuItem>
            <MenuItem value="other">Other</MenuItem>
            <MenuItem value="blank one">Blank One</MenuItem>
            <MenuItem value="blank two">Blank Two</MenuItem>
          </CustomTextField>
          <Button variant="contained" component="label">
            Upload File
            <input
              type="file"
              hidden
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) setDocumentFile(file);
              }}
            />
          </Button>
          {documentFile && (
            <Typography variant="body2" color="textSecondary">
              Selected: {documentFile.name}
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setDialogDocumentOpen(false)}>Cancel</Button>
        <Button
          onClick={handleSaveDocument}
          startIcon={
            loading ? <CircularProgress size={20} color="inherit" /> : null
          }
          variant="contained"
          disabled={!documentName || !documentFile || loading}
        >
          {loading ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UploadDocuments;
